const action = {
  setKurir: ({ commit }: any, payload: any) => {
    commit('SET_KURIR', payload)
  },
}
export default action